import { useSelector, useDispatch } from 'react-redux';
import { logout } from 'store/accountReducer';

// ===========================|| AUTH HOOKS ||=========================== //

const useAuth = () => {
    const dispatch = useDispatch();

    return {
        logout: () => dispatch(logout()),
        ...useSelector((state) => state.account)
    };
};

export default useAuth;
